module.exports = __webpack_public_path__ + "img/Kalsiy_Forte_1280x1010.04d4980f.jpg";